<div class="agpr-aiSettingForm">
    <!-- Key Narratives -->
    <div class="agpr-aiSettingForm-formGroup">
        <div class="agpr-aiSettingForm-formGroupHeader">
            <div
                class="agpr-aiSettingForm-formGroupHeader-title"
                role="heading"
                [attr.aria-level]="headingLevel"
            >
                {{ 'Common.dialog.aiHelper.keyMessages' | localize }}
                <span class="agpr-aiSettingForm-formGroupHeader-asterisk">*</span>
            </div>
            <span class="fa-regular fa-circle-info agpr-infoIconStyle" [agprTooltip]="'Common.dialog.aiHelper.keyMessages.hover'"></span>
            <agpr-button
                *ngIf="value?.keyMessages.length !== MAX_KEY_MESSAGES"
                class="agpr-aiSettingForm-formGroupAddButton"
                [style]="buttonEnum.icon"
                [icon]="'fa-regular fa-duotone fa-duotone fa-square-plus'"
                (click)="addKeyMessage()"
                [tooltip]="'Common.dialog.aiHelper.keyMessages.addKeyMessageTooltip' | localize"
            ></agpr-button>
        </div>
        <ng-container *ngFor="let keyMessage of value?.keyMessages; let index = index; trackBy: trackByIndex">
            <div
                class="agpr-aiSettingForm-formGroupMessage agpr-contextMenu-parent"
            >
                <agpr-textarea-input
                    [id]="'key_message_' + index"
                    [ngModel]="value?.keyMessages[index]"
                    [resize]="resizeDirectionEnum.none"
                    [placeholder]="'Common.dialog.aiHelper.keyMessages.placeholder'"
                    [maxLength]="256"
                    [rows]="5"
                    [icon]="'fa-kit-duotone fa-agpr-ai-generic'"
                    (ngModelChange)="updateKeyMessage($event, index)"
                    (focus)="showQuickTip(aiQuickTipEnums.KEY_MESSAGES)"
                ></agpr-textarea-input>
                <div
                    *ngIf="value?.keyMessages?.length > 1"
                    class="agpr-contextMenu bottom right"
                >
                    <agpr-button
                        [id]="'delete_message_' + index"
                        class="agpr-aiSettingForm-contextButton agpr-aiSettingForm-contextButton--bottomRight agpr-aiSettingForm-contextButton--bottomLeft"
                        icon="fa-regular fa-duotone fa-trash-can"
                        tooltip="Common.dialog.aiHelper.remove.message"
                        tooltipPosition="top"
                        [style]="buttonEnum.contextMenu"
                        (click)="removeMessage(index)"
                    ></agpr-button>
                </div>
            </div>
        </ng-container>
    </div>
    <!-- Quotes -->
    <div class="agpr-aiSettingForm-formGroup">
        <div class="agpr-aiSettingForm-formGroupHeader">
            <div
                class="agpr-aiSettingForm-formGroupHeader-title"
                role="heading"
                [attr.aria-level]="headingLevel"
            >
                {{ 'Common.dialog.aiHelper.quotesHeader' | localize }}
            </div>
            <span class="fa-regular fa-circle-info agpr-infoIconStyle" [agprTooltip]="'Common.dialog.aiHelper.quotesHover'"></span>
            <agpr-button
                *ngIf="value?.quotes.length !== MAX_QUOTES"
                class="agpr-aiSettingForm-formGroupAddButton"
                [style]="buttonEnum.icon"
                [icon]="'fa-regular fa-duotone fa-square-plus'"
                (click)="addQuote()"
                [tooltip]="'Common.dialog.aiHelper.quotesaddTooltip' | localize"
            ></agpr-button>
        </div>
        <div
            *ngIf="value?.quotes.length === 0"
            class="agpr-aiSettingForm-formGroupQuoteNone"
        >
            {{ 'Common.dialog.aiHelper.noQuotes' | localize }}
        </div>
        <div
            *ngFor="let quote of value?.quotes; let index = index; trackBy: trackByIndex"
            class="agpr-aiSettingForm-formGroupQuote agpr-contextMenu-parent"
        >
            <agpr-textarea-input
                [id]="'quote_text_' + index"
                [label]="'Common.dialog.aiHelper.quoteLabel' | localize: { number: index+1 }"
                [placeholder]="'Common.dialog.aiHelper.quotesPlaceholder'"
                [(ngModel)]="quote.text"
                [resize]="resizeDirectionEnum.none"
                [autoGrow]="true"
                [maxLength]="256"
                [icon]="'fa-kit-duotone fa-agpr-ai-generic'"
                (focus)="showQuickTip(aiQuickTipEnums.QUOTES)"
            ></agpr-textarea-input>
            <div class="agpr-aiSettingForm-formGroupQuoteLabel">
                {{ 'Common.dialog.aiHelper.quoteMakerLabel' | localize }}
            </div>
            <div class="agpr-aiSettingForm-formGroupQuoteRow agpr-aiSettingForm-formGroupQuoteRow-field">
                <agpr-text-input
                    [id]="'quote_name_' + index"
                    [label]="'Common.dialog.aiHelper.quoteMakerNameFieldLabel' | localize"
                    [placeholder]="'Common.dialog.aiHelper.quoteMakerNameFieldPlaceholder'"
                    [(ngModel)]="quote.name"
                    [maxLength]="64"
                    (focus)="showQuickTip(aiQuickTipEnums.QUOTES)"
                >
                </agpr-text-input>
                <agpr-text-input
                    [id]="'quote_organization_' + index"
                    [label]="'Common.dialog.aiHelper.quoteMakerOrganizationFieldLabel' | localize"
                    [placeholder]="'Common.dialog.aiHelper.quoteMakerOrganizationFieldPlaceholder'"
                    [(ngModel)]="quote.organization"
                    [maxLength]="64"
                    (focus)="showQuickTip(aiQuickTipEnums.QUOTES)"
                >
                </agpr-text-input>
            </div>
            <div class="agpr-aiSettingForm-formGroupQuoteRow">
                <agpr-text-input
                    [id]="'quote_title_' + index"
                    [label]="'Common.dialog.aiHelper.quoteMakerTitleFieldLabel' | localize"
                    [placeholder]="'Common.dialog.aiHelper.quoteMakerTitleFieldPlaceholder'"
                    [(ngModel)]="quote.title"
                    [maxLength]="64"
                    (focus)="showQuickTip(aiQuickTipEnums.QUOTES)"
                >
                </agpr-text-input>
            </div>
            <div
                class="agpr-contextMenu bottom right"
            >
                <agpr-button
                    [id]="'delete_quote_' + index"
                    class="agpr-aiSettingForm-contextButton agpr-aiSettingForm-contextButton--bottomRight agpr-aiSettingForm-contextButton--bottomLeft"
                    icon="fa-regular fa-duotone fa-trash-can"
                    tooltip="Common.dialog.aiHelper.remove.quote"
                    tooltipPosition="top"
                    [style]="buttonEnum.contextMenu"
                    (click)="removeQuote(index)"
                ></agpr-button>
            </div>
        </div>
    </div>
    <div class="agpr-aiSettingForm-formGroup">
        <div class="agpr-aiSettingForm-formGroupHeader">
            <div
                class="agpr-aiSettingForm-formGroupHeader-title"
                role="heading"
                [attr.aria-level]="headingLevel"
            >
                {{ 'Common.dialog.aiHelper.settings' | localize }}
            </div>
        </div>
        <div class="agpr-aiSettingForm-formGroupFormatRow">
            <div
                *ngIf="value?.formatConfig.showFormat"
                class="agpr-aiSettingForm-radioColumn"
            >
                <div class="agpr-aiSettingForm-label">
                    {{ 'Common.dialog.aiHelper.pressReleaseFormat' | localize }}
                    <span
                        class="fa-regular fa-circle-info agpr-infoIconStyle agpr-aiSettingForm-formGroupOtherRowIcon"
                        [agprTooltip]="'Common.dialog.aiHelper.pressReleaseFormatTooltip'">
                    </span>
                </div>
                <div
                    role="radiogroup"
                    [attr.aria-label]="'Common.dialog.aiHelper.pressReleaseFormat' | localize"
                    class="agpr-aiSettingForm-radioRow"
                >
                    <agpr-radio
                        *ngFor="let formatOption of formatOptions"
                        [(ngModel)]="selectedFormatOption"
                        [value]="formatOption"
                        [label]="formatOption.label"
                        name="formatOption"
                        (ngModelChange)="formatChange()"
                    >
                    </agpr-radio>
                </div>
            </div>
        </div>
        @if (allowCustomOptions) {
            <div class="agpr-aiSettingForm-formGroupOtherRow">
                <agpr-autocomplete
                    [id]="'aiSettingForm_language_autocomplete'"
                    label="Common.dialog.aiHelper.language"
                    placeholder="Common.dialog.aiHelper.language.placeholder"
                    labelField="label"
                    tooltipInfo="Common.dialog.aiHelper.languageTooltip"
                    [dropdown]="true"
                    dropdownMode="blank"
                    [forceSelection]="false"
                    [clearOnBlur]="false"
                    [sortSuggestions]="false"
                    [suggestions]="languageOptions$"
                    [ngModel]="selectedLanguageOption"
                    (ngModelChange)="languageChange($event)"
                ></agpr-autocomplete>
            </div>
        } @else {
            <div class="agpr-aiSettingForm-formGroupOtherRow">
                <agpr-dropdown
                    class="agpr-aiSettingForm-formGroupHeader-dropdown"
                    label="Common.dialog.aiHelper.language"
                    [options]="languageOptions"
                    [(ngModel)]="selectedLanguageOption"
                    [infoCircleTooltip]="'Common.dialog.aiHelper.languageTooltip'"
                    (ngModelChange)="languageChange($event)"
                >
                </agpr-dropdown>
            </div>
        }
        @if (showTargetAudienceField) {
            <div class="agpr-aiSettingForm-formGroupOtherRow">
                <agpr-autocomplete
                    [id]="'aiSettingForm_targetAudience_autocomplete'"
                    label="Common.dialog.aiHelper.targetAudience"
                    tooltipInfo="Common.dialog.aiHelper.targetAudienceTooltip"
                    placeholder="Common.dialog.aiHelper.targetAudience.placeholder"
                    labelField="label"
                    [dropdown]="true"
                    dropdownMode="blank"
                    [forceSelection]="false"
                    [clearOnBlur]="false"
                    [sortSuggestions]="false"
                    [suggestions]="targetAudienceOptions$"
                    [ngModel]="selectedTargetAudienceOption"
                    (ngModelChange)="targetAudienceSelected($event)"
                ></agpr-autocomplete>
            </div>
        }
        @if (showPurposeField) {
            <div class="agpr-aiSettingForm-formGroupOtherRow">
                <agpr-autocomplete
                    [id]="'aiSettingForm_purpose_autocomplete'"
                    label="Common.dialog.aiHelper.purpose"
                    placeholder="Common.dialog.aiHelper.purpose.placeholder"
                    labelField="label"
                    tooltipInfo="Common.dialog.aiHelper.purposeTooltip"
                    [dropdown]="true"
                    dropdownMode="blank"
                    [forceSelection]="false"
                    [clearOnBlur]="false"
                    [sortSuggestions]="false"
                    [suggestions]="purposeOptions$"
                    [ngModel]="selectedPurposeOption"
                    (ngModelChange)="purposeSelected($event)"
                ></agpr-autocomplete>
            </div>
        }
        @if (allowCustomOptions) {
            <div class="agpr-aiSettingForm-formGroupOtherRow">
                <agpr-autocomplete
                    [id]="'aiSettingForm_tone_autocomplete'"
                    label="Common.dialog.aiHelper.contentTone"
                    placeholder="Common.dialog.aiHelper.contentTone.placeholder"
                    labelField="label"
                    tooltipInfo="Common.dialog.aiHelper.contentToneTooltip"
                    [dropdown]="true"
                    dropdownMode="blank"
                    [forceSelection]="false"
                    [clearOnBlur]="false"
                    [sortSuggestions]="false"
                    [suggestions]="toneOptions$"
                    [ngModel]="selectedToneOption"
                    (ngModelChange)="toneChange($event)"
                ></agpr-autocomplete>
            </div>
        } @else {
            <div class="agpr-aiSettingForm-formGroupOtherRow">
                <agpr-dropdown
                    class="agpr-aiSettingForm-formGroupHeader-dropdown"
                    label="Common.dialog.aiHelper.contentTone"
                    [options]="toneOptions"
                    [(ngModel)]="selectedToneOption"
                    [infoCircleTooltip]="'Common.dialog.aiHelper.contentToneTooltip'"
                    (ngModelChange)="toneChange($event)"
                >
                </agpr-dropdown>
            </div>
        }
        <div class="agpr-aiSettingForm-formGroupOtherRow">
            <agpr-dropdown
                class="agpr-aiSettingForm-formGroupHeader-dropdown"
                label="Common.dialog.aiHelper.pressReleaseLength"
                [options]="lengthOptions"
                [(ngModel)]="selectedLengthOption"
                [infoCircleTooltip]="'Common.dialog.aiHelper.pressReleaseLengthTooltip'"
                (ngModelChange)="lengthChange()"
            >
            </agpr-dropdown>
        </div>
    </div>
</div>
